module.exports = __webpack_public_path__ + "static/img/applet.1bcfc06.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/h5/applet.jpg
// module id = ABAh
// module chunks = 0